export const mobileMax = 967;
// export const mobileMax = 740;

export const BANNER_HEIGHT = 100;
